export const CART_INITIALISED = 'cart:initialised'
export const CART_UPDATED = 'cart:updated'

export const NOTICE_ADD_TO_CART = 'cart-notice:add-to-cart'
export const NOTICE_UPDATE_QUANTITY = 'cart-notice:update-quantity'
export const SHOW_CART_MODAL = 'cart-modal'

export const CART_VIEWED = 'cart:viewed'
